export const getIsE2E = () => (window as any).Cypress !== undefined;

export const useIsE2E = () => {
    return getIsE2E();
};
